import { httpCreate } from './http';

const http = httpCreate('/shop/api/activity-blind-box');

export const activityBlindBox = {
	/** 获取盲盒列表
	 * @param { Number } params.pageNum
	 * @param { Number } params.pageSize
	 * @param { Number } params.liveStatus
	 * @param { String } params.title
	 * @param { String } params.activityTitle
	 */
	getBlindBoxList(params) {
		return http.get('/list', { params });
	},
	// 盲盒开启、关闭
	switch(id, status) {
		return http.put(`/${id}/switch/${status}`);
	},
	/** 保存盲盒
	 * @param { Number } activityId
	 * @param { String } data.title      //名称
	 * @param { Number } data.startTime  //开始时间
	 * @param { Number } data.endTime    //结束时间
	 * @param { String } data.description //活动描述
	 * @param { Number } data.cueCardButton //0关 1开
	 */
	saveBox(activityId, data) {
		return http.post(`/${activityId}`, data);
	},
	// 根据直播间id获取信息
	getBoxInfo(activityId, params) {
		return http.get(`/${activityId}`, { params });
	},
	/** 修改盲盒
	 * @param { Number } data.activityId	// 关联直播间id
	 * @param { String } data.title      //名称
	 * @param { Number } data.startTime  //开始时间
	 * @param { Number } data.endTime    //结束时间
	 * @param { String } data.description //活动描述
	 * @param { Number } data.cueCardButton //0关 1开
	 */
	editBox(boxId, data) {
		return http.put(`${boxId}`, data);
	},
	// 删除盲盒活动
	deleteBox(boxId) {
		return http.delete(`${boxId}`);
	},
	// 根据盲盒活动id获取信息
	getBoxInfoByBoxId(boxId, params) {
		return http.get(`/getById/${boxId}`, { params });
	},
};
